import React from 'react'
import TeamBG from '../../../../assets/bg/pc/bg_team.png'

const TeamPCComponent = () => {
  return <img src={TeamBG} />
}

export default TeamPCComponent
